import React from 'react';
import styles from './styles.module.css';

const Pagenation = ({ totalPages, currentPage, setCurrentPage }) => {
  return (
    <ol className={styles.pagination}>
      <li
        className={styles.prev}
        onClick={() => {
          if (currentPage) setCurrentPage(currentPage - 1);
        }}
      >
        &lt;
      </li>
      {Array.from({ length: totalPages }, (_, i) => i).map((number) => (
        <li
          key={number}
          onClick={() => setCurrentPage(number)}
          className={currentPage === number ? styles.current : styles.others}
        >
          {number + 1}
        </li>
      ))}
      <li
        className={styles.next}
        onClick={() => {
          if (currentPage < totalPages - 1) setCurrentPage(currentPage + 1);
        }}
      >
        &gt;
      </li>
    </ol>
  );
};

export default Pagenation;
